"use client";

import { cn } from "@/utils/helpers";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import * as React from "react";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

// const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

// INFO: grabbed this snippet from GitHub to add transition animation

const CollapsibleContent = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.CollapsibleContent>,
  React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent>
>(({ className, children, ...props }, ref) => (
  // INFO: don't apply padding directly to CollapsiblePrimitive.CollapsibleContent, otherwise it will cause stuturing, so we add an additional div
  <CollapsiblePrimitive.CollapsibleContent
    ref={ref}
    className="overflow-hidden transition-all data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down"
    {...props}
  >
    <div className={className}>{children}</div>
  </CollapsiblePrimitive.CollapsibleContent>
));
CollapsibleContent.displayName = "CollapsibleContent";

// INFO: when using "CollapsibleTriggerLi", add "group-li" on common parent

function CollapsibleTriggerLi({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <CollapsibleTrigger
      className={cn(
        "border border-b-0 group-first/li:rounded-t-xl group-first/li:border-t group-last/li:rounded-b-xl group-last/li:border-b data-[state=open]:border-b data-[state=open]:group-last/li:rounded-b-none",
        className,
      )}
    >
      {children}
    </CollapsibleTrigger>
  );
}

export { Collapsible, CollapsibleContent, CollapsibleTrigger, CollapsibleTriggerLi };
